export const apiUrl = (...endpoints) => {
  let path = endpoints.join('/')
  return `/api/${path}/`
}

export const aiApiUrl = (...endpoints) => {
  let path = endpoints.join('/')
  const baseUrl = process.env.VUE_APP_CHATGPT_API_URL || 'https://chatgpt.dentco.tw/api'
  return `${baseUrl}/${path}/`
}
